import React, {
    FunctionComponent,
    useEffect,
    useState,
} from "react";
import styles from "./Nav.module.scss";
import WellsFargoLogo from "./../../images/svgs/wellsfargo-logo";
import {fireGA} from '../../hooks/tagging';


const Nav: FunctionComponent<{}> = ({}) => {
    const [loaded, setLoaded] = useState(false);

    // need to get check for physical device for WCAG zoom support
    let isMobileDevice = true;
    const device = window.navigator.userAgent.toLowerCase();

    if (device.indexOf('iphone') === -1 && device.indexOf('ipad') === -1 && device.indexOf('android') === -1) {
        isMobileDevice = false;
    }

    let checkForZoom = () => {

        let nav = document.querySelectorAll<HTMLElement>("#nav")[0];

        if (!isMobileDevice) {
            if (window.outerWidth / window.innerWidth >= 2) {
                nav.style.position = "relative";
                document.querySelector<HTMLElement>("#root")!.style.paddingTop = "0px"

            }
            else {
                nav.style.position = "fixed";
                document.querySelector<HTMLElement>("#root")!.style.paddingTop = "60px"
            }
        }
    }

    useEffect(() => {
        if (!loaded) {
            document.querySelector<HTMLElement>("#root")!.style.paddingTop = document.querySelector("#nav")!.getBoundingClientRect().height + "px";

            window.addEventListener("resize", function () {
                document.querySelector<HTMLElement>("#root")!.style.paddingTop = document.querySelector("#nav")!.getBoundingClientRect().height + "px";
                checkForZoom();
            });

            checkForZoom();
            setLoaded(true);
        }
    }, [loaded]);

    return (
        <nav id="nav" className={styles.nav} data-lang={process.env.REACT_APP_LANG === "spanish" ? 'es' : 'en'}>
            <div className={styles.pillar} data-lang={process.env.REACT_APP_LANG === "spanish" ? 'es' : 'en'}>
                <a
                    href={process.env.REACT_APP_LANG === "spanish" ? 'https://www.wellsfargo.com/es/' : 'https://www.wellsfargo.com/'}

                    tabIndex={0}
                    data-location={'nonwhite background'}
                    aria-label={process.env.REACT_APP_LANG === 'spanish' ? 'Logotipo de Wells Fargo' : 'Wells Fargo Homepage'}
                    title={process.env.REACT_APP_LANG === 'spanish' ? 'Abre en una nueva ventana del navegador' : 'Opens in a new tab'}
                    onClick={() => {
                        fireGA('G1') //good
                    }}
                    onKeyUp={(e) => {
                        if (e.which === 13) {
                            fireGA('G1')//good
                        }
                    }}
                    target="_blank">
                    <WellsFargoLogo/>
                </a>
            </div>
        </nav>
    );
};

export default Nav;
